import React, { FC } from 'react';
import { IconButton } from '../IconButton';
import { i18n } from '../../../i18n';

interface ShowHidePasswordButtonProps {
  toggleShowPassword: () => void;
  showPassword: boolean;
}

export const ShowHidePasswordButton: FC<ShowHidePasswordButtonProps> = ({ showPassword, toggleShowPassword }) => {
  return (
    <IconButton
      ariaLabel={showPassword ? i18n.t('Hide password') : i18n.t('Show password')}
      variant="ghost"
      size="sm"
      onClick={toggleShowPassword}
      icon={{ iconName: showPassword ? 'eye-slash' : 'eye', prefix: 'fas' }}
    />
  );
};
